// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__2pdKt","ul":"sidebar_ul__3Az7K","li":"sidebar_li__RHROS","subitem":"sidebar_subitem__EMhG3"};